import NftSummaryView from "../views/nft/NftSummaryView.vue";
import NFTOrderView from "../views/nft/NFTOrderView.vue";

import useProgressBarActions from "@/composables/progress/useProgressBarActions";

const { updateToComplete, updateToPending, resetAllProgress } =
  useProgressBarActions();

const routes = [
  {
    path: "/nft",
    name: "nft.order",
    component: NFTOrderView,
    beforeEnter() {
      resetAllProgress();
    },
  },
  {
    path: "/nft/transit",
    name: "nft.order.transit",
    component: NFTOrderView,
    beforeEnter() {
      resetAllProgress();
    },
  },
  {
    path: "/nft/status/:orderId",
    name: "nft.summary",
    component: NftSummaryView,
    beforeEnter() {
      updateToComplete(["verification", "identity", "payment"]);
    },
  },
];

export default routes;
